import {
  lightBlue,
  grey,
  indigo,
} from '@material-ui/core/colors';
import logo from './images/logo.png';
import logoms from './images/logoms.png';

import bg from './images/bg.jpg';

export default {
  palette: {
    primary1Color: lightBlue[500],
    primary2Color: lightBlue[700],
    primary3Color: grey[400],
    accent1Color: indigo[500],
    accent2Color: grey[100],
    accent3Color: grey[500],
    textColor: grey[900],
    alternateTextColor: grey[50],
    canvasColor: grey[50],
    borderColor: grey[300],
    disabledColor: grey[800],
    pickerHeaderColor: indigo[500],
    clockCircleColor: grey[800],
    shadowColor: grey[900],
  },
  appBar: {
    height: 57,
    // color: lightBlue500,
  },
  drawer: {
    width: 230,
    // color: brown50,
  },
  raisedButton: {
    // primaryColor: lightBlue500,
  },
  logo,
  logoms,
  //bg,
};



// WEBPACK FOOTER //
// ./src/theme-config.js